/* eslint-disable import/prefer-default-export */
export enum UserAuthorityType {
    MOBILE_UPDATE_REQUIRED_BY_NULL = 'MOBILE_UPDATE_REQUIRED_BY_NULL',
    USER_15_TEEN = 'USER_15_TEEN',
    LONG_TERM_INACTIVE_VERIFICATION_REQUIRED = 'LONG_TERM_INACTIVE_VERIFICATION_REQUIRED',
    PASSWORD_CHANGE_REQUIRED = 'PASSWORD_CHANGE_REQUIRED',
    PARTNERSHIP = 'PARTNERSHIP',
}
